import {
    Breadcrumb,
    Button,
    Dropdown,
    Flex,
    Form,
    Modal,
    Select,
    Table,
    Tag,
    Typography,
    notification,
} from "antd";
import {
    ClockCircleOutlined,
    DeleteOutlined,
    DisconnectOutlined,
    DotChartOutlined,
    DownOutlined,
    EditOutlined,
    PlayCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useSesion from "../../../Hooks/Sesion";
import { useInstitucion } from "../../../Hooks/Institucion/useInstitucion";
import { useAtleta } from "../../../Hooks/Atleta/useAtleta";
import { Atom } from "react-loading-indicators";
import useBle from "../../../Hooks/Ble";
import BleConexionControles from "../../../Contexts/Ble/BleConexionControles";

const TIPOS_PRUEBA = [
    { value: "cmj", label: "CMJ (Counter Movement Jump)" },
    { value: "nordic", label: "Nordic Curl" },
    { value: "dynamo", label: "Dynamo" },
];

const etiquetaTipo = (tipo) => TIPOS_PRUEBA.find((t) => t.value === tipo)?.label ?? tipo;

const esClickEnAcciones = (target) =>
    Boolean(target?.closest?.(".ant-dropdown, .ant-dropdown-trigger, .ant-btn, button, a"));

const AtletaListado = () => {
    const navigate = useNavigate();
    const { usuario } = useSesion();
    const { instituciones, getInstitucion, getAllInstitucion } = useInstitucion();
    const { atletas, getAtletas, deleteAtleta } = useAtleta();
    const [cargando, setCargando] = useState(false);
    const [modalIniciar, setModalIniciar] = useState(false);
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);

    const {
        conectado,
        cargando: cargandoBle,
        sesionDesdeAtletas,
        tipoPruebaSesion,
        simulacionVisible,
        esAdmin,
        conectar,
        continuarSimulacion,
        omitirSoloBluetooth,
        iniciarSesionAtletas,
        finalizarSesionAtletas,
        marcarNavegacionAPrueba,
        debePreservarSesionAtletas,
        limpiarPreservarSesionAtletas,
    } = useBle();

    const sesionAtletasRef = useRef(false);
    sesionAtletasRef.current = sesionDesdeAtletas;

    const miga = [
        {
            title: <Link to="/">Inicio</Link>,
        },
        {
            title: "Atletas",
        },
    ];

    const irAPrueba = (atleta, tipo) => {
        if (sesionDesdeAtletas && !conectado) {
            notification.warning({
                description: "La sesión de pruebas perdió la conexión. Pulsa «Iniciar pruebas» de nuevo.",
            });
            return;
        }
        if (sesionDesdeAtletas) {
            marcarNavegacionAPrueba();
        }
        console.log(atleta)
        console.log(`/atleta/${atleta._id}/iniciar-prueba/${tipo}`)
        navigate(`/atleta/${atleta._id}/iniciar-prueba/${tipo}`);
    };

    const sesionActiva = sesionDesdeAtletas && conectado && tipoPruebaSesion;

    const menuSinSesion = [
        { label: "Editar", key: "1", icon: <EditOutlined /> },
        { label: "Iniciar COP", key: "7", icon: <ClockCircleOutlined /> },
        { label: "Iniciar CMJ", key: "2", icon: <ClockCircleOutlined /> },
        { label: "Iniciar Nordic Curl", key: "3", icon: <ClockCircleOutlined /> },
        { label: "Iniciar Dynamo", key: "4", icon: <ClockCircleOutlined /> },
        { label: "Tendencias", key: "5", icon: <DotChartOutlined /> },
        { label: "Borrar", key: "6", icon: <DeleteOutlined />, danger: true },
    ];

    const menuConSesion = [
        { label: "Editar", key: "1", icon: <EditOutlined /> },
        { label: "Tendencias", key: "5", icon: <DotChartOutlined /> },
        { label: "Borrar", key: "6", icon: <DeleteOutlined />, danger: true },
    ];

    const Acciones = ({ atleta }) => {
        const items = sesionActiva ? menuConSesion : menuSinSesion;

        const click = ({ key, domEvent }) => {
            domEvent?.stopPropagation();

            if (key === "1") {
                navigate(`/atleta/${atleta._id}/actualizar`);
                return;
            }

            if (key === "2") {
                irAPrueba(atleta, "cmj");
                return;
            }

            if (key === "3") {
                irAPrueba(atleta, "nordic");
                return;
            }

            if (key === "4") {
                irAPrueba(atleta, "dynamo");
                return;
            }

            if (key === "5") {
                navigate(`/atleta/${atleta._id}/tendencias`);
                return;
            }

            if (key === "6") {
                deleteAtleta(atleta._id);
                cargar({});
            }
            if (key === "7") {
                irAPrueba(atleta, "cop");
                return;
            }
        };

        return (
            <span onClick={(e) => e.stopPropagation()}>
                <Dropdown.Button icon={<DownOutlined />} menu={{ items, onClick: click }}>
                    Acciones
                </Dropdown.Button>
            </span>
        );
    };

    const cargarIns = async () => {
        setCargando(true);
        try {
            usuario?.rol === "Admin" ? await getAllInstitucion() : await getInstitucion(usuario?.institucion);
        } catch (error) {
            notification.error({ description: error.response.data.mensaje });
            navigate("/atletas");
        } finally {
            setCargando(false);
        }
    };

    const cargar = async (param) => {
        try {
            setCargando(true);
            await getAtletas(param);
        } catch (error) {
            notification.error({ description: error.response.data.mensaje });
        } finally {
            setCargando(false);
        }
    };

    const abrirModalIniciar = () => {
        setTipoSeleccionado(tipoPruebaSesion);
        setModalIniciar(true);
    };

    const cerrarModalIniciar = () => {
        setModalIniciar(false);
        setTipoSeleccionado(null);
    };

    const toggleSesionPruebas = async () => {
        if (sesionDesdeAtletas && conectado) {
            await finalizarSesionAtletas();
            notification.info({ description: "Dispositivo desconectado." });
            return;
        }
        abrirModalIniciar();
    };

    const onOmitirBluetoothAtletas = () => {
        if (!tipoSeleccionado) {
            notification.warning({ description: "Selecciona el tipo de prueba antes de continuar." });
            return;
        }
        omitirSoloBluetooth();
    };

    const onClickFilaAtleta = (atleta, event) => {
        if (!sesionActiva || esClickEnAcciones(event.target)) return;
        irAPrueba(atleta, tipoPruebaSesion);
    };

    useEffect(() => {
        if (!modalIniciar || !tipoSeleccionado || !conectado) return;
        iniciarSesionAtletas(tipoSeleccionado);
        cerrarModalIniciar();
        notification.success({
            description: `Listo. Haz clic en un atleta para iniciar ${etiquetaTipo(tipoSeleccionado)}.`,
        });
    }, [modalIniciar, tipoSeleccionado, conectado, iniciarSesionAtletas]);

    useEffect(() => {
        cargarIns();
        cargar({});
    }, []);

    useEffect(() => {
        return () => {
            const preservar = debePreservarSesionAtletas();
            if (sesionAtletasRef.current && !preservar) {
                finalizarSesionAtletas();
            }
            if (preservar) {
                limpiarPreservarSesionAtletas();
            }
        };
    }, [debePreservarSesionAtletas, finalizarSesionAtletas, limpiarPreservarSesionAtletas]);

    return (
        <div style={{ padding: 32 }}>
            <Flex gap="middle" align="center" justify="space-between" wrap="wrap">
                <Flex gap="middle" align="center">
                    <Breadcrumb items={miga} />
                    <Link to="/atleta/guardar">
                        <Button icon={<PlusOutlined />} />
                    </Link>
                </Flex>
                <Flex gap="small" align="center" wrap="wrap">
                    {sesionActiva ? (
                        <Tag color="success">{etiquetaTipo(tipoPruebaSesion)}</Tag>
                    ) : null}
                    <Button
                        type={sesionActiva ? "default" : "primary"}
                        danger={sesionActiva}
                        icon={sesionActiva ? <DisconnectOutlined /> : <PlayCircleOutlined />}
                        onClick={toggleSesionPruebas}
                    >
                        {sesionActiva ? "Desconectar" : "Iniciar pruebas"}
                    </Button>
                </Flex>
            </Flex>
            <br />
            {sesionActiva ? (
                <Typography.Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
                    Haz clic en un atleta de la tabla para iniciar la prueba.
                </Typography.Text>
            ) : null}
            <Form onFinish={cargar}>
                <Form.Item name={"institucion"} label="Institución">
                    <Select
                        options={instituciones.map((i) => ({ value: i._id, label: i.nombre }))}
                        defaultValue={instituciones[usuario?.institucion]}
                        allowClear={usuario?.rol === "Admin"}
                    />
                </Form.Item>
                <Button type="primary" htmlType="submit">
                    Filtrar
                </Button>
            </Form>
            <br />
            {cargando ? (
                <Flex align="center" justify="center">
                    <Atom color="#32cd32" size="medium" text="" textColor="" />
                </Flex>
            ) : (
                <Table
                    rowKey={"_id"}
                    loading={cargando}
                    dataSource={atletas}
                    pagination={false}
                    onRow={(record) => ({
                        onClick: (e) => onClickFilaAtleta(record, e),
                        style: sesionActiva ? { cursor: "pointer" } : undefined,
                    })}
                    rowClassName={() => (sesionActiva ? "fila-atleta-prueba" : "")}
                >
                    <Table.Column title="Nombre" dataIndex={"nombre"} />
                    <Table.Column title="Ide." dataIndex={"ide"} />
                    <Table.Column title="Peso" dataIndex={"peso"} />
                    <Table.Column
                        title="Instituciones"
                        render={(d) => (d.institucion ? d.institucion.nombre : "Sin institución")}
                    />
                    <Table.Column title="Acciones" render={(d) => <Acciones atleta={d} />} />
                </Table>
            )}

            <Modal
                open={modalIniciar}
                title="Iniciar pruebas"
                onCancel={cerrarModalIniciar}
                footer={null}
                maskClosable={false}
                destroyOnClose
            >
                <Flex vertical gap="middle">
                    <Typography.Text type="secondary">
                        Elige el tipo de prueba y conecta la balanza. Luego haz clic en el atleta para comenzar.
                    </Typography.Text>
                    <Form layout="vertical">
                        <Form.Item label="Tipo de prueba" required>
                            <Select
                                placeholder="Selecciona CMJ, Nordic o Dynamo"
                                options={TIPOS_PRUEBA}
                                value={tipoSeleccionado}
                                onChange={setTipoSeleccionado}
                            />
                        </Form.Item>
                    </Form>
                    <BleConexionControles
                        cargando={cargandoBle}
                        onConectar={() => {
                            if (!tipoSeleccionado) {
                                notification.warning({ description: "Selecciona el tipo de prueba primero." });
                                return;
                            }
                            conectar();
                        }}
                        onSimulacion={() => {
                            if (!tipoSeleccionado) {
                                notification.warning({ description: "Selecciona el tipo de prueba primero." });
                                return;
                            }
                            continuarSimulacion();
                        }}
                        onOmitir={onOmitirBluetoothAtletas}
                        simulacionVisible={simulacionVisible}
                        esAdmin={esAdmin}
                        disabled={!tipoSeleccionado}
                    />
                </Flex>
            </Modal>
        </div>
    );
};

export default AtletaListado;
